import React from 'react';

import { motion } from 'framer-motion';



const Footer: React.FC = () => {

  return (

    <motion.footer

      initial={{ opacity: 0 }}

      whileInView={{ opacity: 1 }}

      viewport={{ once: true, amount: 0.2 }}

      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}

      className="border-t border-[var(--color-border)] mt-24"

    >

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">

          <p className="text-sm text-[var(--color-muted)]">

            {new Date().getFullYear()} Tornado Corp. All Rights Reserved.

          </p>

          <a

            href="https://x.com/fanofaliens"

            target="_blank"

            rel="noopener noreferrer"

            aria-label="X (formerly Twitter)"

            className="text-[var(--color-muted)] hover:text-[var(--color-foreground)] transition-colors duration-300"

          >

            <span className="font-sans text-sm font-medium">𝕏</span>

          </a>

        </div>

      </div>

    </motion.footer>

  );

};



export default Footer;